<template>
  <listheader />
  <documentacaoItem 
    :item="item"
    v-for="item in listItems" />
  <slot></slot>  
</template>

<script>
import documentacaoItem from './documentacaoItem.vue';
import listheader from './listheader.vue';

export default {
  props: ["listItems", "fetching"],
  components: {
    documentacaoItem,
    listheader
  }
}
</script>